import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

function TutorialRoom() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', color: '#0f172a', p: { xs: 2, sm: 4 } }}>
      <Stack spacing={2.5} sx={{ maxWidth: 720, mx: 'auto', pt: { xs: 4, sm: 8 } }}>
        <Typography variant="h4" component="h1" fontWeight={900}>
          チュートリアルイベント
        </Typography>
        <Typography sx={{ color: '#475569', lineHeight: 1.8 }}>
          次のステップで、イベント内のお題確認、ポイントを使った予想、結果確認の流れを作っていきます。
        </Typography>
        <Button href="/tutorial" variant="outlined" sx={{ alignSelf: 'flex-start', fontWeight: 900 }}>
          チュートリアルTOPへ戻る
        </Button>
      </Stack>
    </Box>
  );
}

export default TutorialRoom;
